/** Official Tanow mark — three open teal arcs around a clay centre. `tone="dark"` for deep/dark grounds. */
export default function TanowMark({ size = 24, tone = 'light', className = '', title = 'Tanow' }) {
    const arc = tone === 'dark' ? '#A9D6CC' : '#146B5E';
    const dot = tone === 'dark' ? '#E8A268' : '#C8763F';
    return (
        <svg viewBox="0 0 64 64" width={size} height={size} fill="none" role="img" aria-label={title} className={className} data-testid="tanow-mark">
            <path d="M23.38 10.67 A23 23 0 0 1 54.32 26.44" stroke={arc} strokeWidth="6.5" strokeLinecap="round" />
            <path d="M54.78 35.20 A23 23 0 0 1 25.66 54.11" stroke={arc} strokeWidth="6.5" strokeLinecap="round" />
            <path d="M17.84 50.12 A23 23 0 0 1 16.02 15.46" stroke={arc} strokeWidth="6.5" strokeLinecap="round" />
            <circle cx="32" cy="32" r="8" fill={dot} />
        </svg>
    );
}
